import CustomInput from '@app/components/CustomInput'
import { ISign, Sign } from '@app/models/Sign'
import { ISignType, SignType } from '@app/models/SignType'
import { IGlobalSignTypesState } from '@app/store/modules/global'
import { bindFunctions } from '@app/utils/class'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { List } from 'immutable'
import * as React from 'react'
import { Button, Input, InputGroup, InputGroupAddon } from 'reactstrap'
import { InputType } from 'reactstrap/lib/Input'

interface IComponentProps {
  addLabel?: string
  className?: string
  name?: string
  value: List<ISign>
  onChange: (newValue: List<ISign>) => void
  style?: React.CSSProperties
  type?: InputType
}

export default class SignListEditor extends React.PureComponent<
  IComponentProps & IGlobalSignTypesState
> {
  constructor(props: any) {
    super(props)
    bindFunctions(this)
  }

  public render() {
    return (
      <div className={this.props.className} style={this.props.style}>
        <div className='mb-2'>
          <Button color='primary' outline onClick={this._addItem} size='sm'>
            {this.props.addLabel || 'Add Item'}
          </Button>
        </div>
        {this.props.value.toArray().map((val: ISign, i: number) => {
          const sign = (val as Sign).toJS()
          return (
            <div
              key={`sign-${i}`}
              className='d-flex flex-row flex-wrap align-items-center'
            >
              <CustomInput
                className='mr-2'
                min={1}
                name={`Sign${i + 1}Quantity`}
                onChange={(e) => this._changeQuantity(i, e)}
                type='number'
                value={sign.quantity}
                step='1'
                style={{ flex: 1 }}
              />
              <Input
                required
                invalid={!sign.signType.id}
                style={{ flex: 2 }}
                name={`Sign${i + 1}Type`}
                className='mr-2'
                type='select'
                value={sign.signType.id}
                onChange={(e) =>
                  this._changeSignType(
                    i,
                    this.props.signTypes.find((item?: ISignType) => {
                      if (!item) {
                        return false
                      }
                      return item.id === e.target.value
                    }),
                  )
                }
              >
                {!sign.signType.id && <option value='' />}
                {this.props.signTypes
                  .map((c: any, index: any) => (
                    <option key={`signType-${index}`} value={c.id}>
                      {c.name}
                    </option>
                  ))
                  .toJS()}
              </Input>

              <InputGroup
                key={`item-${i}`}
                className='mb-2 mt-2'
                style={{ flex: 6 }}
              >
                <Input
                  placeholder='Enter notes...'
                  type={this.props.type || 'text'}
                  onChange={(e) => this._changeNotes(i, e.target.value)}
                  value={sign.notes}
                />
                <InputGroupAddon addonType='append'>
                  <Button
                    color='danger'
                    onClick={() => this._deleteItem(i)}
                    outline
                    title='Delete'
                  >
                    <FontAwesomeIcon icon={['fal', 'trash']} fixedWidth />
                  </Button>
                </InputGroupAddon>
              </InputGroup>
            </div>
          )
        })}
      </div>
    )
  }

  private _addItem() {
    this.props.onChange(this.props.value.push(Sign.fromJS()))
  }

  private _changeQuantity(index: number, newValue: number) {
    this.props.onChange(this.props.value.setIn([index, 'quantity'], newValue))
  }

  private _changeSignType(index: number, newValue: ISignType) {
    this.props.onChange(this.props.value.setIn([index, 'signType'], newValue))
  }

  private _changeNotes(index: number, newValue: string) {
    this.props.onChange(this.props.value.setIn([index, 'notes'], newValue))
  }

  private _deleteItem(index: number) {
    this.props.onChange(this.props.value.delete(index))
  }
}
